/**
 * Asset Management Services Module
 * Exports all asset management services and the factory function.
 */
export { AssetService } from './AssetService';
export { AssetScanService } from './AssetScanService';
export { AssetSettingsService } from './AssetSettingsService';
export { AssetStatusService } from './AssetStatusService';
export { AssetCategoryService } from './AssetCategoryService';
export { AssetTypeService } from './AssetTypeService';
export { AssetConditionService } from './AssetConditionService';
export { AssetAssignmentTypeService } from './AssetAssignmentTypeService';
export { AssetScanTypeService } from './AssetScanTypeService';
export { AssetScanPurposeService } from './AssetScanPurposeService';
export { AssetTagTypeService } from './AssetTagTypeService';
export { MaintenanceTypeService } from './MaintenanceTypeService';
export { DepreciationMethodService } from './DepreciationMethodService';
export { AssetLogTypeService } from './AssetLogTypeService';
export { AssetEntrancePointService } from './AssetEntrancePointService';
import { AssetService } from './AssetService';
import { AssetScanService } from './AssetScanService';
import { AssetSettingsService } from './AssetSettingsService';
import { AssetStatusService } from './AssetStatusService';
import { AssetCategoryService } from './AssetCategoryService';
import { AssetTypeService } from './AssetTypeService';
import { AssetConditionService } from './AssetConditionService';
import { AssetAssignmentTypeService } from './AssetAssignmentTypeService';
import { AssetScanTypeService } from './AssetScanTypeService';
import { AssetScanPurposeService } from './AssetScanPurposeService';
import { AssetTagTypeService } from './AssetTagTypeService';
import { MaintenanceTypeService } from './MaintenanceTypeService';
import { DepreciationMethodService } from './DepreciationMethodService';
import { AssetLogTypeService } from './AssetLogTypeService';
import { AssetEntrancePointService } from './AssetEntrancePointService';
/**
 * Create all asset management services with shared configuration.
 */
export function createAssetManagementServices(http, config) {
    return {
        asset: new AssetService(http, config),
        assetScan: new AssetScanService(http, config),
        assetSettings: new AssetSettingsService(http, config),
        assetStatus: new AssetStatusService(http, config),
        assetCategory: new AssetCategoryService(http, config),
        assetType: new AssetTypeService(http, config),
        assetCondition: new AssetConditionService(http, config),
        assetAssignmentType: new AssetAssignmentTypeService(http, config),
        assetScanType: new AssetScanTypeService(http, config),
        assetScanPurpose: new AssetScanPurposeService(http, config),
        assetTagType: new AssetTagTypeService(http, config),
        maintenanceType: new MaintenanceTypeService(http, config),
        depreciationMethod: new DepreciationMethodService(http, config),
        assetLogType: new AssetLogTypeService(http, config),
        assetEntrancePoint: new AssetEntrancePointService(http, config),
    };
}
//# sourceMappingURL=index.js.map